<template>
    <app-main>
        <app-content>

            <div class="flex flex-wrap -mx-2">
                <div class="w-full md:w-1/2 px-2">
                    <!-- Start Title -->
                    <app-title
                        title="Translations"
                        sub-title="Translate the strings"
                    />
                    <!-- End Title -->
                </div>
                <div class="w-full md:w-1/2 px-2 md:text-right">
                     <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="save">
                        Save
                    </app-button>
                </div>
            </div>

            <app-box :loading="loading" :initial="loading">
                <div v-if="translations.length > 0">
                    <div 
                        class="flex items-center mb-6 -mx-3"
                        v-for="(trans, ti) in translations"
                        :key="ti"
                    >
                        <div class="w-1/3 md:w-1/4 xl:w-1/5 px-3">
                            <em>"{{  trans.string }}"</em>
                        </div>
                        <div class="flex-grow px-3">
                            <div class="flex -mx-3">
                                <div
                                    v-for="(locale, li) in trans.locales"
                                    :key="li"
                                    class="px-3"
                                >
                                    <div class="relative">
                                        <app-field-text
                                            class="reset"
                                            :classes="{ input: { 'input--locale': true } }"
                                            :placeholder="locale.lang"
                                            v-model="locale.translation"
                                        />

                                         <img :src="require(`../../assets/img/flags/${locale.flag}.png`)" class="absolute" style="top: 1rem; right: 0.75rem; width: 30px; height: 18px;"  />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </app-box>
        </app-content>
    </app-main>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';
    /* Components */
    import Main from '@/components/Main';
    import Content from '@/components/template/Content';
    import Title from '@/components/Title';
    import Box from '@/components/Box';
    import Button from '@/components/Button';
    import TextField from '@/components/fields/inputs/Text';

    /* Mixins */
    import ValidationErrors from '@/mixins/validationErrors.js';

    export default {
        name: 'translations.home',

        data: () => ({
            translations: [],
            fields: {
                data: []
            },
            loading: false,
            errors: {}
        }),

        components: {
            'app-main': Main,
            'app-content': Content,
            'app-title': Title,
            'app-box': Box,
            'app-button': Button,
            'app-field-text': TextField
        },

        mixins: [
            ValidationErrors
        ],

        mounted() {
            this.loading = true;

            this.getTranslations()
                .then(response => {
                    this.loading = false;
                })
        },

        methods: {
            getTranslations() {
                return Api.request('get', `translations`)
                    .then(({ data }) => {
                        this.translations = data;
                    });
            },
            save() {
                this.loading = true;
                this.clearErrors();

                let i,j,temparray,chunk = 50;
                for (i=0,j=this.translations.length; i<j; i+=chunk) {
                    temparray = this.translations.slice(i,i+chunk);

                    let test = i + chunk;
                    Api.request('post', `translations/update`, {translations: this.translations}).then(response => {
                        if(typeof response.data.message != 'undefined' && test > this.translations.length) {
                            this.$toasted.show(response.data.message, {
                                type: "success",
                                position: "bottom-right",
                                duration : 5000
                            });

                            this.loading = false;
                        }
                    }).catch(error => {
                        if(this.hasErrors(error)) {
                            this.addErrors(error);
                        }
                    });
                }
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/translations/Home.vue